export default __webpack_public_path__ + "static/media/codewars_icon.4f399b30.png";